import React from 'react';
import elencoMailForm from '../data/ElencoMailForm';

const MailFormContext = React.createContext(elencoMailForm);

export { MailFormContext as default };
